import { Button } from '@cp/ds/src/components/button';
import { Stack } from '@cp/ds/src/components/stack';
import { Typography } from '@cp/ds/src/components/typography';
import { useTheme } from '@cp/ds/src/hooks';
import { CloseIcon, LogoIcon } from '@cp/ds/src/icons';
import React from 'react';
import { useIsAndroid, useIsIOS, useIsSafari, useIsStandalone } from 'src/shared/mediaQueries';

let isClosedGlobal = false;

export const MobileAppBanner: React.FC = () => {
  const isAndroid = useIsAndroid();
  const isIOS = useIsIOS();
  const isSafari = useIsSafari();
  const theme = useTheme();
  const isStandalone = useIsStandalone();
  const [isClosed, setClosed] = React.useState(isClosedGlobal);

  if (isStandalone || (!isAndroid && !isIOS) || isClosed) {
    return null;
  }

  if (isIOS && isSafari) {
    return null;
  }

  return (
    <Stack alignItems="center" direction="row" justifyContent="flex-start" sx={{ py: 1, pl: 1, pr: 2 }}>
      <Button
        onClick={() => {
          setClosed(true);
          isClosedGlobal = true;
        }}
        variant="text"
      >
        <CloseIcon sx={{ color: theme.palette['gray middle'] }} />
      </Button>

      <LogoIcon fontSize="2rem" sx={{ color: theme.palette['brand pink'], mx: 1 }} />

      <Stack direction="column" justifyContent="center" spacing={0.25}>
        <Typography variant="body bold">Юхелп: найти работу/помощника</Typography>
        <Typography variant="caption">Легкий поиск объявлений здесь</Typography>
      </Stack>

      <Button
        color="gray"
        onClick={() => {
          window.location.href = isIOS
            ? 'https://apps.apple.com/ru/app/youhelp/id1536935575'
            : 'https://play.google.com/store/apps/details?id=ru.youhelp.app';
        }}
        size="extraSmall"
        sx={{ ml: 'auto' }}
        variant="primary"
      >
        Скачать
      </Button>
    </Stack>
  );
};
